import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// Radix-Dialoge zentrieren per CSS-Transform (translate(-50%,-50%)).
// html2canvas rendert Elemente in transformierten/scrollenden Containern verzerrt ("gequetscht").
// Fix: Element klonen und außerhalb des Dialogs (ohne Transform) rendern.
export const captureCertificateAsDataUrl = async (element) => {
  const width = element.offsetWidth;
  const wrapper = document.createElement('div');
  wrapper.style.cssText = `position:absolute;top:0;left:0;z-index:10;background:#ffffff;padding:10px;width:${width + 20}px;pointer-events:none;`;
  const clone = element.cloneNode(true);
  clone.style.transform = 'none';
  clone.style.margin = '0';
  wrapper.appendChild(clone);
  document.body.appendChild(wrapper);
  try {
    const canvas = await html2canvas(wrapper, {
      scale: 2,
      backgroundColor: '#ffffff',
      useCORS: true,
      allowTaint: true,
      logging: false,
      scrollX: 0,
      scrollY: 0,
      windowWidth: document.documentElement.offsetWidth,
      windowHeight: document.documentElement.offsetHeight
    });
    return canvas.toDataURL('image/png', 1.0);
  } finally {
    document.body.removeChild(wrapper);
  }
};

// Exportiert das Zertifikat als DIN-A4-PDF (Hochformat, zentriert mit Rand)
export const downloadCertificateAsPdf = async (element, fileName) => {
  const dataUrl = await captureCertificateAsDataUrl(element);
  const img = new Image();
  await new Promise((resolve) => { img.onload = resolve; img.src = dataUrl; });
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageW = 210, pageH = 297, margin = 12;
  const ratio = img.width / img.height;
  let w = pageW - 2 * margin;
  let h = w / ratio;
  if (h > pageH - 2 * margin) {
    h = pageH - 2 * margin;
    w = h * ratio;
  }
  pdf.addImage(dataUrl, 'PNG', (pageW - w) / 2, (pageH - h) / 2, w, h);
  pdf.save(fileName);
};
